/*
  Desktop "View as" control: switches the product grid between 3 and 4 columns.

  The override class is applied to #ProductGridContainer rather than to #product-grid itself,
  because facets.js replaces the container's innerHTML on every filter/sort change -- the
  container element survives, the grid inside it does not. Putting the class on the survivor
  means the chosen layout persists across filtering with no re-binding or re-applying.
*/
(() => {
  const DESKTOP_QUERY = '(min-width: 990px)';
  const CLASS_PREFIX = 'product-grid-container--cols-';

  const init = () => {
    const container = document.getElementById('ProductGridContainer');
    const buttons = document.querySelectorAll('.view-as__button');
    if (!container || !buttons.length) return;

    const desktop = window.matchMedia(DESKTOP_QUERY);

    const apply = (columns) => {
      // Snapshot first: classList is live, so removing while iterating it skips entries.
      Array.from(container.classList)
        .filter((name) => name.startsWith(CLASS_PREFIX))
        .forEach((name) => container.classList.remove(name));
      container.classList.add(`${CLASS_PREFIX}${columns}`);

      buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.gridColumns === columns));
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (!desktop.matches) return;
        apply(button.dataset.gridColumns);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
